module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "disclaimer-modal-content"
  }, [_c('h2', [_vm._v("Disclaimer")]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.formattedDisclaimer)
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button button-grey",
    style: (_vm.buttonStyle),
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Close")])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a1ed3a12", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a1ed3a12"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/components/inventory/price-disclaimer.vue
// module id = 860
// module chunks = 0